export default __webpack_public_path__ + "static/media/siteLogo.fce37564.png";